import Vue from 'vue'
import Vuex from 'vuex'
import vuetify from "../plugins/vuetify";


Vue.use(Vuex)


export const store = new Vuex.Store({
    state: {
        count: 0,
        style: {
            fontFamily: 'font-family:IRANSans,serif'
        },
        current_lang: 'fa',
        base_url: 'https://madresefestival.ir/if/api',
        upload_url: 'https://madresefestival.ir/if/api/submission/document/upload/',
        snack_bar: {
            show: true,
            text: '',
            type: 0,
        }
    },
    mutations: {
        increment(state) {
            vuetify.rtl = false
            state.count++
        },
        set_font(state, newValue) {
            state.style.fontFamily = newValue
        },
        //======================= Snack Bar Function =======================\\
        show_snackbar(state, payload) {
            state.snack_bar.show = true
            state.snack_bar.text = payload.text
            state.snack_bar.type = payload.type
        },
        hide_snackbar(state) {
            state.snack_bar.show = false
            state.snack_bar.text = ""
        },
        toggle_drawer(state) {
            state.drawer = !state.drawer
        },
        set_user_data(state, payload) {
            state.user_data = payload
        },
        //======================= END OF Snack Bar Function =======================\\
    },
    getters: {
        style: (state) => {
            return state.style.fontFamily
        },
        language: (state) => {
            return state.current_lang
        },
        get_snack_bar_color: state => {
            switch (state.snack_bar.type) {
                case 0:
                    return 'primary'
                case 1:
                    return 'success'
                case 2:
                    console.log('error')
                    return 'error'
            }
        }
    },
    actions: {
        setFont: ({commit, state}, newValue) => {
            commit('set_font', newValue)
            return state.style.fontFamily
        }
    }
})
